import { RoutesPlannerRun, UpdateVehicleOnRunProps } from '@bringg-frontend/routes-planner';
import { Task } from '@bringg/types';

const geVehicleAssignerModalParams = (
	run: RoutesPlannerRun,
	runTasks: Task[],
	teamId: number,
	onClose: ({ runId, vehicleId, tasksIds }: UpdateVehicleOnRunProps) => void
) => {
	const vehicleId = run.vehicle_id;
	const trailerId = runTasks.find(t => t.vehicle_id && t.vehicle_id !== vehicleId)?.vehicle_id;

	const params = {
		vehicleId,
		trailerId,
		userId: run.user_id,
		runId: run.id,
		tasks: runTasks,
		teamIds: [teamId],
		weight: { maxValue: run.max_weight, value: run.weight_capacity }
	};

	const modalParams = {
		data: params,
		tasks: runTasks,
		handleListUpdate: ({ runId, vehicleId, tasksIds }) => onClose({ runId, vehicleId, tasksIds }),
		hideUnassignVehicleButton: true,
		doNotNotifyServerOnAssign: true
	};
	return modalParams;
};

export const vehicleAssignerModalOpener = { geVehicleAssignerModalParams };
